/**
 * Created by jhcao on 2020/05/22.
 * 会员权益JSON数据
 */

var titleArr = ['产品免费测试包', '产品免费礼包', '乐享会员试用', '产品抵扣券',
  '服务市场入驻免押金', '1024开发者节', '线下技术沙龙邀约', '服务市场品牌加持', '专属服务集群', '1V1技术支持']

/**
 * 处理会员等级权限
 */
function memberType (level, index) {
  var out = {}
  switch (level) {
    case 'L1':
      if (index === 0 || index === 1 || index === 2) {
        out.type = true
        out.btnTitle = '领取'
      } else {
        out.type = false
        out.btnTitle = '等级不足'
      }
      break
    case 'L2':
      if (index === 0 || index === 1 || index === 2 || index === 3) {
        out.type = true
        out.btnTitle = '领取'
      } else {
        out.type = false
        out.btnTitle = '等级不足'
      }
      break
    case 'L3':
      if (index === 0 || index === 1 || index === 2 || index === 3 || index === 4) {
        out.type = true
        out.btnTitle = (index <= 3) ? '领取' : '查看'
      } else {
        out.type = false
        out.btnTitle = '等级不足'
      }
      break
    case 'L4':
      if (index === 9 || index === 8 || index === 7) {
        out.type = false
        out.btnTitle = '等级不足'
      } else {
        out.type = true
        out.btnTitle = (index <= 3) ? '领取' : '查看'
      }
      break
    case 'L5':
      if (index === 9 || index === 8 || index === 7) {
        out.type = false
        out.btnTitle = '等级不足'
      } else {
        out.type = true
        out.btnTitle = (index <= 3) ? '领取' : '查看'
      }
      break
    case 'L6':
      if (index === 9) {
        out.type = false
        out.btnTitle = '等级不足'
      } else {
        out.type = true
        out.btnTitle = (index <= 3) ? '领取' : '查看'
      }
      break
    case 'L7':
      out.type = true
      out.btnTitle = (index <= 3) ? '领取' : '查看'
      break
    default:
      out.type = !index
      out.btnTitle = index ? '等级不足' : '领取'
      break
  }
  return out
}

function memberEquityData (level = 'L0') {
  var memberData = []
  for (var i = 0; i < 10; i++) {
    var obj = {
      id: i,
      title: titleArr[i],
      type: memberType(level, i).type,
      btnTitle: memberType(level, i).btnTitle
    }
    memberData.push(obj)
  }
  return memberData
}

function memberEquityImgData () {
  var img = [
    {
      selected: require('assets/img/member/equity/vip-selected-001.png'),
      unselected: require('assets/img/member/equity/vip-unselected-001.png'),
      unpower: require('assets/img/member/equity/vip-unpower-001.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-002.png'),
      unselected: require('assets/img/member/equity/vip-unselected-002.png'),
      unpower: require('assets/img/member/equity/vip-unpower-002.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-003.png'),
      unselected: require('assets/img/member/equity/vip-unselected-003.png'),
      unpower: require('assets/img/member/equity/vip-unpower-003.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-004.png'),
      unselected: require('assets/img/member/equity/vip-unselected-004.png'),
      unpower: require('assets/img/member/equity/vip-unpower-004.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-005.png'),
      unselected: require('assets/img/member/equity/vip-unselected-005.png'),
      unpower: require('assets/img/member/equity/vip-unpower-005.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-006.png'),
      unselected: require('assets/img/member/equity/vip-unselected-006.png'),
      unpower: require('assets/img/member/equity/vip-unpower-006.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-007.png'),
      unselected: require('assets/img/member/equity/vip-unselected-007.png'),
      unpower: require('assets/img/member/equity/vip-unpower-007.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-008.png'),
      unselected: require('assets/img/member/equity/vip-unselected-008.png'),
      unpower: require('assets/img/member/equity/vip-unpower-008.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-009.png'),
      unselected: require('assets/img/member/equity/vip-unselected-009.png'),
      unpower: require('assets/img/member/equity/vip-unpower-009.png')
    },
    {
      selected: require('assets/img/member/equity/vip-selected-010.png'),
      unselected: require('assets/img/member/equity/vip-unselected-010.png'),
      unpower: require('assets/img/member/equity/vip-unpower-010.png')
    }
  ]
  return img
}

export { memberEquityData, memberEquityImgData }



// WEBPACK FOOTER //
// ./src/js/libs/json/member-equity.js